export const noEventsContainerStyleProps = {
    display: 'flex',
    flexDirection: {base: 'column', mobileXL: 'row'},
    justifyContent: 'space-between',
    gap: '16px',
    margin: {base: '16px', mobileXL: '24px'},
    padding: {base: '16px', mobileXL: '24px'},
};

export const noEventsInfoStyleProps = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexBasis: '50%',
};

export const noEventsTitleStyleProps = {
    fontSize: '18px',
    fontWeight: 'semibold',
    paddingBottom: '16px',
};

export const noEventsInfoListStyleProps = {
    alignSelf: 'flex-start',
    paddingBottom: '16px',
};

export const noEventsInfoItemStyleProps = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '14px',
    marginBottom: '8px',
};

export const noEventsIconStyleProps = {
    marginRight: '12px',
    height: '16px',
    width: '16px',
    fill: 'success',
};

export const noEventsMapStyleProps = {
    order: {base: -1, mobileXL: 'unset'},
    display: 'flex',
    justifyContent: 'center',
};

export const noEventsMapImageStyleProps = {
    maxWidth: {base: '100%', tablet: '306px'},
    maxHeight: {base: '163px', tablet: '200px'},
    width: '100%',
    objectFit: 'cover',
};

export const noEventsButtonStyleProps = {
    fontSize: '14px',
    fontWeight: 'normal',
    textDecoration: 'none',
};
